import * as Yup from "yup";
import { allocationCodeRequiredIfType } from "./allocation";
import { isNotFutureDate } from "./validationUtils";
const { generateCustomFieldsValidation } = require("./customFieldValidations");

const expenseTypeValidationSchema = Yup.object().shape({
  expenseType: Yup.string().required("Expense type is required"),
});

const cashExpenseBase = Yup.object().shape({
  expenseType: Yup.string().required("Expense type is required"),
  description: Yup.string().required("Reason is required"),
  payTo: Yup.object()
    .shape({
      id: Yup.string().required("Pay to is required"),
    })
    .nullable()
    .required("Pay to is required"),
  date: Yup.date()
    .typeError("Please select a valid date")
    .required("Date is required")
    .test("not-in-future", "Date cannot be in the future", isNotFutureDate),
  amount: Yup.number()
    .required("Amount is required")
    .min(0.01, "Amount must be greater than 0"),
  merchant: Yup.object().required("Merchant is required"),
  lostReceipt: Yup.boolean(),
  attachments: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string().required(),
        assetUrl: Yup.string().required(),
      }),
    )
    .when("lostReceipt", {
      is: true,
      then: (schema) => schema.notRequired().min(0),
      otherwise: (schema) =>
        schema
          .min(1, "At least one attachment is required")
          .required("Attachments are required"),
    }),
  allocationType: Yup.object()
    .shape({
      key: Yup.string(),
      name: Yup.string(),
    })
    .nullable(),
  allocationCode: Yup.object()
    .shape({
      id: Yup.string(),
      allocationCode: Yup.string(),
    })
    .test(
      "allocation-required",
      "Allocation Name is required when an Allocation Type is selected",
      allocationCodeRequiredIfType(),
    ),
});

const mileageExpenseBase = Yup.object().shape({
  expenseType: Yup.string().required("Expense type is required"),
  description: Yup.string().required("Reason is required"),
  payTo: Yup.object()
    .shape({
      id: Yup.string().required("Pay to is required"),
    })
    .nullable()
    .required("Pay to is required"),
  date: Yup.date()
    .typeError("Please select a valid date")
    .required("Date is required")
    .test("not-in-future", "Date cannot be in the future", isNotFutureDate),
  tripFrom: Yup.object()
    .shape({
      addressName: Yup.string().required("From location is required"),
      address1: Yup.string().required("Please select a valid address"),
    })
    .required("From location is required"),
  tripTo: Yup.object()
    .shape({
      addressName: Yup.string().required("To location is required"),
      address1: Yup.string().required("Please select a valid address"),
    })
    .required("To location is required"),
  distance: Yup.number()
    .required("Distance is required")
    .min(1, "Distance must be at least 1 mile"),
  allocationType: Yup.object()
    .shape({
      key: Yup.string(),
      name: Yup.string(),
    })
    .nullable(),
  allocationCode: Yup.object()
    .shape({
      id: Yup.string(),
      allocationCode: Yup.string(),
    })
    .test(
      "allocation-required",
      "Allocation Name is required when an Allocation Type is selected",
      allocationCodeRequiredIfType(),
    ),
});

const generateCashExpenseValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return cashExpenseBase.concat(
    Yup.object({
      customFields: customFieldsSchema,
    }),
  );
};

const generateMileageExpenseValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return mileageExpenseBase.concat(
    Yup.object({
      customFields: customFieldsSchema,
    }),
  );
};

export {
  expenseTypeValidationSchema,
  generateMileageExpenseValidationSchema,
  generateCashExpenseValidationSchema,
};
